import React, { useState, useEffect, useContext } from 'react';
import { Typography, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField } from "@mui/material";
import Paper from '@mui/material/Paper';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { styled } from '@mui/material/styles';
import { AntTabs, AntTab } from '../tabs_style';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import dayjs from 'dayjs';
import html2pdf from 'html2pdf.js';
import 'dayjs/locale/es'; // Importa el archivo de localización para español
import logoinjupempblack from '../../../Components/image.png';


export default function Resumen({ nombre, apellido, modulo }) {
  const [tabIndex, setTabIndex] = React.useState(0);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [rows, setRows] = useState([
    {
      id: 1,
      inicio: null,
      final: null,
      errors: {
        inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
        final: { fechaVacia: false, invalidFormat: false, cleared: false }
      }
    },
    {
      id: 2,
      inicio: null,
      final: null,
      errors: {
        inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
        final: { fechaVacia: false, invalidFormat: false, cleared: false }
      }
    },
    {
      id: 3,
      inicio: null,
      final: null,
      errors: {
        inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
        final: { fechaVacia: false, invalidFormat: false, cleared: false }
      }
    }
  ]);

  const data = [
    { description: 'COTIZACIONES SEGÚN SISTEMA', amount: 'L. 0.00' },
    { description: 'OTROS', amount: 'L. 0.00', msj: 'MÁS' },
    { description: 'REBAJA DE COTIZACIONES', amount: 'L. 0.00', msj: 'MENOS' },
    { description: 'OTROS', amount: 'L. 0.00', msj: 'MENOS' },
    { description: 'VALOR NETO DE COTIZACIONES', amount: 'L. 0.00' },
    { description: 'INTERESES', amount: 'L. 0.12', msj: "MÁS" },
    { description: 'COTIZACIONES MAS INTERESES', amount: 'L. 0.12' },
    { description: 'FACTOR DE RESCATE', amount: '0.90', msj: "POR" },
    { description: 'MONTO DEL BENEFICIO', amount: 'L. 0.11' },
  ];

  function CustomDatePickerTabla({ rowId, field, label, selectedDate, errors, ...props }) {
    const today = dayjs();

    useEffect(() => {
      if (errors.cleared) {
        const timeout = setTimeout(() => {
          setRows(rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                errors: {
                  ...row.errors,
                  [field]: { ...row.errors[field], cleared: false }
                }
              };
            }
            return row;
          }));
        }, 1500);

        return () => clearTimeout(timeout);
      }
      return () => { };
    }, [errors.cleared, rowId, field]);

    const handleKeyDown = (event) => {
      event.preventDefault();
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoItem>
          <DatePicker
            // disabled
            format={"DD/MM/YYYY"}
            value={selectedDate}
            views={['year', 'month', 'day']}
            label={label}
            slotProps={{
              field: { clearable: true },
              textField: {
                variant: "standard",
                // disabled: true,
                helperText: errors.fechaVacia ? `Seleccione la ${label}` :
                  errors.invalidFormat ? "Formato de fecha incorrecto" :
                    (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" :
                      errors.invalidRange ? "La Fecha Final no puede ser menor que la Fecha Inicio" : null),
                error: errors.fechaVacia || errors.invalidFormat || errors.invalidRange,
                onKeyDown: handleKeyDown,
              },
            }}
            maxDate={today}
            {...props}
          />
        </DemoItem>
        {errors.cleared && (
          <Alert
            sx={{ position: 'absolute', bottom: 0, right: 0 }}
            severity="success"
          >
            Fecha Borrada!
          </Alert>
        )}
      </LocalizationProvider>
    );
  }

  const handlePrint = () => {
    const element = document.getElementById('cardContent');
    const cardContent = element.cloneNode(true); // Clonamos el contenido del Card para no afectar la vista actual

    // Reducimos el tamaño de la letra y la tabla
    const styles = `

      #cardContent table th, #cardContent table td {
        padding: 1px; /* Reducimos el padding de las celdas de la tabla */
      }
      #cardContent table {
        width: 100%; /* Ajustamos el ancho de la tabla */
      }
      #cardContent >.MuiCard-root {
        border: none; /* Eliminamos el borde del Card */
      }
    `;
    const styleElement = document.createElement('style');
    styleElement.innerHTML = styles;
    cardContent.appendChild(styleElement);

    html2pdf()
      .set({
        margin: 0.5, // Ajustamos el margen del PDF
        filename: 'resumen.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 5 }, // Ajustamos la escala del PDF
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      })
      .from(cardContent)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          //pdf.setFontSize(4); // Reducimos el tamaño de la letra para mejor ajuste
        }
      })
      .save();
  };

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Resumen</h2>
          </div>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Tasas Por Año" />
                <AntTab label="Monto Del Beneficio" />
                <AntTab label="Datos" />
                <AntTab label="Cálculos" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {/* Contenido de la pestaña actual */}
            {tabIndex === 0}
            {tabIndex === 1 && navigate('/Separaciones/TablaDeInteres')}
            {tabIndex === 2 && navigate('/Separaciones/Tasas')}
            {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficio')}
            {tabIndex === 4 && navigate('/Separaciones/LeyActual')}
            {tabIndex === 5 && navigate('/Separaciones/Calculos')}
          </Box>
        </Container>
      </Grid>

      <Box marginTop={2} id="cardContent" >
        {/*<Stack display="flex" alignItems="center" width="100%">
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" flex="1">
            <img src={logoinjupempblack} alt="Logo INJUPEMP" style={{ maxWidth: '130px', maxHeight: '130px' }} />
            <Typography style={{ textAlign: 'center', marginTop: '10px' }} variant="h6">
              <b>RESUMEN DE SEPARACIÓN DEL SISTEMA</b>
            </Typography>
          </Box>
        </Stack>*/}

        <Stack display="flex" width="100%">
          <Box display="flex" flexDirection="row" justifyContent="space-around" alignItems="center" flex="1">
            <Typography style={{ textAlign: 'center', marginTop: '10px' }} variant="h6">
              <b>RESUMEN DE SEPARACIÓN DEL SISTEMA</b>
            </Typography>
            <img src={logoinjupempblack} alt="Logo INJUPEMP" style={{ maxWidth: '130px', maxHeight: '130px' }} />
          </Box>
        </Stack>

        <Card variant='standard'>
          <CardContent>
            <Stack direction="row">
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="nombreparticipante"
                    label="Nombre Del Participante"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
              </Grid>
            </Stack>
            <Stack direction="row" >
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="identidad"
                    label="Número De Tarjeta De Identidad"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="cotizante"
                    label="Cotizante"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" >
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="edadactual"
                    label="Edad Actual"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="dependencia"
                    label="Dependencia"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" >
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="ramo"
                    label="Ramo"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="tiemposolicitado"
                    label="Tiempo De Servicio Solicitado (Años)"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" >
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="fechasolicitud"
                    label="Fecha De Solicitud"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="tasainteres"
                    label="Tasa De Interés Utilizada"
                    variant="standard"
                  // disabled
                  />
                </FormControl>
              </Grid>
            </Stack>


            <Container style={{ marginTop: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h6"><strong>Detalle De Períodos</strong></Typography>
              </div>
            </Container>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>#</strong></TableCell>
                    <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Inicio</strong></TableCell>
                    <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Final</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell style={{ textAlign: 'center', fontSize: 16 }}>
                        <label><strong>{row.id}</strong></label>
                      </TableCell>
                      <TableCell>
                        <CustomDatePickerTabla
                          rowId={row.id}
                          field='inicio'
                          //label="Fecha Inicio"
                          selectedDate={row.inicio}
                          errors={row.errors.inicio}
                        />
                      </TableCell>
                      <TableCell>
                        <CustomDatePickerTabla
                          rowId={row.id}
                          field='final'
                          //label="Fecha Final"
                          selectedDate={row.final}
                          errors={row.errors.final}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>


            <Container style={{ marginTop: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h6"><strong>Detalle De Cálculos</strong></Typography>
              </div>
            </Container>
            <TableContainer component={Paper}>
              <Table aria-label="cotizaciones table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontSize: 20, backgroundColor: '#eeeeee' }}><b></b></TableCell>
                    <TableCell style={{ fontSize: 20, backgroundColor: '#eeeeee' }}><b>Descripción</b></TableCell>
                    <TableCell style={{ fontSize: 20, textAlign: 'center', backgroundColor: 'lightgrey' }}><b>Monto</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((row, index) => (
                    <TableRow key={row.description}>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          backgroundColor: index % 2 === 0 ? 'white' : '#eeeeee',
                          width: '10px',
                          textAlign: 'center'
                        }}
                      >
                        {row.msj}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ backgroundColor: index % 2 === 0 ? 'white' : '#eeeeee', }}
                      >
                        <b>{row.description}</b>
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        sx={{ backgroundColor: index % 2 === 0 ? 'white' : 'lightgray' }}
                      >
                        {row.amount}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Typography sx={{ padding: 2, marginTop: 1 }}>
              FUNDAMENTO LEGAL: ARTICULO 73 DE BENEFICIO DE TRANSFERENCIA DE VALORES ACTUARIALES
              O SEPARACIÓN DEL SISTEMA, EFECTIVO A PARTIR DEL 13 DE MAYO 2014
              "Observación: A través del presente resumen, completadas las firmas correspondientes, la División de
              Beneficios recomienda la continuación del procedimiento para la aprobación y pago de este beneficio"
            </Typography>
          </CardContent>
        </Card>

        <Stack display="flex" width="100%" marginTop={5}>
          <Box display="flex" flexDirection="row" justifyContent="space-around" alignItems="center" flex="1">
            <Typography textAlign={'center'}>
              ___________________________ <br /> Firma Analista
            </Typography>
            <Typography textAlign={'center'}>
              ___________________________ <br /> Firma Revisor
            </Typography>
          </Box>
        </Stack>

        <Stack display="flex" width="100%" marginTop={10}>
          <Box display="flex" flexDirection="row" justifyContent="space-around" alignItems="center" flex="1">
            <Typography textAlign={'center'}>
              ___________________________ <br /> Firma Coordinador De Separaciones
            </Typography>
            <Typography textAlign={'center'}>
              ___________________________ <br /> Firma Jefe De Beneficios
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
        <Button
          variant="contained"
          startIcon={<PrintIcon style={{ fontSize: 40 }} />}
          size='large'
          style={{ width: '200px', height: '50px', backgroundColor: "#AD8401"}}
          onClick={handlePrint}
        >
          Imprimir
        </Button>
      </Container>
    </>
  );
}
